"use client";

import { createContext, useContext, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

const DrawerContext = createContext();

export const DrawerProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [drawerContent, setDrawerContent] = useState(<div>Drawer</div>);
  const ref = useRef(null);


  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, [ref]);

  return (
    <DrawerContext.Provider
      value={{ open, setOpen, drawerContent, setDrawerContent, ref }}
    >
      {children}
    </DrawerContext.Provider>
  );
};

DrawerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useDrawerContext = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error("useDrawerContext must be used within a DrawerProvider");
  }
  return context;
};
